import { useStoreContact } from "@/context/StoreContactContext";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { NAV_LINKS, BRAND } from "@/lib/data";

const goToSection = (href) => {
  const el = document.querySelector(href);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  } else {
    window.location.href = `/${href}`;
  }
};

export const Footer = () => {
  const contact = useStoreContact();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-foreground text-primary-foreground grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-display text-5xl tracking-tight leading-none">
              {BRAND.name}
            </div>
            <p className="mt-3 font-mono-label text-[0.65rem] uppercase tracking-[0.28em] text-accent">
              Super Market · Since {BRAND.established}
            </p>
            <p className="mt-8 text-white/60 text-base leading-relaxed max-w-sm">
              {BRAND.address}
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-mono-label text-[0.65rem] uppercase tracking-widest text-white/40 mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => goToSection(l.href)}
                    className="text-white/80 hover:text-accent transition-colors duration-300"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-label text-[0.65rem] uppercase tracking-widest text-white/40 mb-6">
              Get In Touch
            </h4>
            <ul className="space-y-3 text-white/80">
              {contact.phone && <li>
                <a href={contact.phoneHref} className="hover:text-accent transition-colors duration-300" data-testid="footer-phone">
                  {contact.phone}
                </a>
              </li>}
              {contact.email && <li>
                <a href={`mailto:${contact.email}`} className="hover:text-accent transition-colors duration-300" data-testid="footer-email">
                  {contact.email}
                </a>
              </li>}
              <li className="text-white/60">{BRAND.hours}</li>
              <li className="flex items-center gap-2 pt-1">
                <span className="text-accent">★</span> {BRAND.rating} · {BRAND.reviews}+ reviews
              </li>
            </ul>
          </div>
        </div>

        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mt-16 h-px bg-white/15 origin-left"
        />
        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-4 text-white/40 text-xs font-mono-label uppercase tracking-widest">
          <span>© {year} {BRAND.name}. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="hover:text-accent transition-colors duration-300" data-testid="footer-terms">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy" className="hover:text-accent transition-colors duration-300" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/delete-account" className="hover:text-accent transition-colors duration-300" data-testid="footer-delete-account">
              Delete Account
            </Link>
            <span className="hidden sm:inline">{BRAND.locality}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
